import { createFileRoute } from '@tanstack/react-router';
import { NotificationPreferencesPage } from '@/pages/settings/NotificationPreferencesPage';

export const Route = createFileRoute('/_authenticated/_app/settings/notifications')({
	component: NotificationPreferencesPage,
});
